export default "__VITE_ASSET__CK0sv0Wt__"